import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyerCountries, buyerNames, images } from '../data/content';
type Purchase = {
  name: string;
  country: string;
  minutes: number;
};
const pick = <T,>(list: T[]): T => list[Math.floor(Math.random() * list.length)];
const nextPurchase = (): Purchase => ({
  name: pick(buyerNames),
  country: pick(buyerCountries),
  minutes: Math.floor(Math.random() * 14) + 1
});
export function PurchasePopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setPurchase(nextPurchase());
      hideTimer = window.setTimeout(() => setPurchase(null), 5000);
    };
    const firstTimer = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 bottom-24 z-40 sm:bottom-28 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-205" data-mp="116micxthqy7m">
      <AnimatePresence data-id="element-206" data-mp="1awpm9t25hwkq">
        {purchase && !dismissed && <motion.div key={`${purchase.name}-${purchase.country}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-card ring-1 ring-navy/10 sm:w-[360px]" data-id="element-207" data-mp="1axheqv0gbe6s">
            <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-cream object-contain" data-id="element-208" data-mp="28j544vyhow8t" />
            <div className="min-w-0" data-id="element-209" data-mp="23l3ic39oiitn">
              <p className="text-[14px] leading-snug text-ink" data-id="element-210" data-mp="2aotk8d64zvi5">
                <strong data-id="element-211" data-mp="2aobhcxoyyj19">{purchase.name}</strong> from <strong data-id="element-212" data-mp="2fneapkvl70te">{purchase.country}</strong> just purchased the AAC Clinical Blueprint™
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-213" data-mp="2km7qjjycj3wq">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-214" data-mp="2pmdlb8zwx6j1" />
                {purchase.minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-cream" data-id="element-215" data-mp="1rzwo03r6isxa">
              <XIcon className="h-4 w-4" data-id="element-216" data-mp="26nhnzosrcc0z" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}